import { useSelector } from 'react-redux';
import { useLocalStorage } from '../../../../../../helpers/storage';
import { draftName } from '../constants';

export const useDraftLocalStorage = () => {
  const { WorkerId } = useSelector((state) => state.authentication.userInfo);
  return useLocalStorage(`${draftName}_${WorkerId}`);
};
